import React from "react";
export default function DeliverIcon() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        // width="22"
        // height="22"
        x="0"
        y="0"
        viewBox="0 0 512 512"
      >
        <g>
          <g fillRule="evenodd" clipRule="evenodd">
            <path
              fill="#ffdc6e"
              d="M16.222 225.508h105.197c6.623 0 12.042-5.419 12.042-12.042V108.27c0-6.623-5.419-12.042-12.042-12.042H16.222c-6.623 0-12.042 5.419-12.042 12.042v105.197c0 6.623 5.419 12.041 12.042 12.041z"
              opacity="1"
              data-original="#ffdc6e"
            ></path>
            <path
              fill="#ffca28"
              d="M110.522 225.508h10.897c6.623 0 12.042-5.419 12.042-12.042V108.27c0-6.623-5.419-12.042-12.042-12.042h-10.897z"
              opacity="1"
              data-original="#ffca28"
            ></path>
            <path
              fill="#f7524b"
              d="M88.029 144.648V96.227H49.612v48.421c0 3.812 2.624 6.922 5.842 6.922h26.734c3.217 0 5.841-3.109 5.841-6.922zM364.91 230.622h52.943l25.193 116.473H364.91z"
              opacity="1"
              data-original="#f7524b"
            ></path>
            <path
              fill="#cb413d"
              d="M364.91 230.622h52.943l10.19 47.112-63.133-23.836z"
              opacity="1"
              data-original="#cb413d"
            ></path>
            <path
              fill="#404049"
              d="M73.476 266.473H240.7c11.166 0 20.301-9.134 20.301-20.299 0-11.166-9.134-20.301-20.301-20.301H93.777c-11.166 0-20.301 9.134-20.301 20.301zM196.152 403.179c0 42.427-34.394 76.821-76.821 76.821S42.51 445.606 42.51 403.179z"
              opacity="1"
              data-original="#404049"
            ></path>
            <path
              fill="#f0f0fc"
              d="M157.596 403.179c0 21.133-17.132 38.265-38.265 38.265s-38.265-17.132-38.265-38.265z"
              opacity="1"
              data-original="#f0f0fc"
            ></path>
            <path
              fill="#404049"
              d="M492.923 403.179c0 42.427-34.394 76.821-76.821 76.821s-76.821-34.394-76.821-76.821z"
              opacity="1"
              data-original="#404049"
            ></path>
            <path
              fill="#f0f0fc"
              d="M454.367 403.179c0 21.133-17.132 38.265-38.265 38.265s-38.265-17.132-38.265-38.265z"
              opacity="1"
              data-original="#f0f0fc"
            ></path>
            <path
              fill="#f7524b"
              d="M27.612 403.179h216.152V258.003H100.199c-39.923 0-72.588 32.664-72.588 72.587v72.589z"
              opacity="1"
              data-original="#f7524b"
            ></path>
            <path
              fill="#f7524b"
              d="M225.365 349.721h127.939v53.457H225.365z"
              opacity="1"
              data-original="#f7524b"
            ></path>
            <path
              fill="#ef444e"
              d="m430.805 171.713-55.965 8.495c-5.753.873-9.93 5.733-9.93 11.551v46.237l65.895 10.002c17.435 2.646 31.956-17.164 31.956-38.143 0-20.016-14.019-40.864-31.956-38.142z"
              opacity="1"
              data-original="#ef444e"
            ></path>
            <path
              fill="#ffdc6e"
              d="M431.549 248.097c17.102 1.981 31.212-17.562 31.212-38.241 0-19.74-13.633-40.285-31.212-38.242z"
              opacity="1"
              data-original="#ffdc6e"
            ></path>
            <path
              fill="#e14844"
              d="M119.33 311.46c50.655 0 91.719 41.064 91.719 91.719H27.612c0-50.655 41.064-91.719 91.718-91.719z"
              opacity="1"
              data-original="#e14844"
            ></path>
            <path
              fill="#ffdc6e"
              d="m150.071 183.686 49.586 23.602 61.944-30.203 38.311 30.537 87.604 25.775 12.482-20.997c-28.441-9.497-51.289-18.729-79.843-30.072l-21.501-27.687s.706-25.499-13.818-38.84c-14.525-13.341-14.615-13.676-14.615-13.676-78.114 2.935-107.922 39.355-120.15 81.561z"
              opacity="1"
              data-original="#ffdc6e"
            ></path>
            <path
              fill="#484a50"
              d="M389.952 237.272c8.752 0 15.89-7.138 15.89-15.89s-7.138-15.889-15.89-15.889-15.89 7.138-15.89 15.889c0 8.752 7.138 15.89 15.89 15.89zM156.012 236.084l106.414 36.748-.984 93.961h34.516L299 256.028c.288-10.478-5.715-19.479-15.273-23.779l-130.273-58.6-11.464 25.485c-6.304 14.016-.506 31.935 14.022 36.95z"
              opacity="1"
              data-original="#484a50"
            ></path>
            <path
              fill="#ffdc6e"
              d="m261.369 362.105-.142 11.974c-.118 10.087 8.501 18.259 18.589 18.096l13.809-.226 16.835-.108c7.243-.046 13.112-5.992 13.066-13.235l-.012-1.766c-.049-7.644-5.92-13.954-13.358-14.736H261.369z"
              opacity="1"
              data-original="#ffdc6e"
            ></path>
            <path
              fill="#ffca28"
              d="m288.03 392.041 5.594-.092 16.835-.108c7.243-.046 13.112-5.992 13.066-13.235l-.012-1.766c-.049-7.644-5.92-13.954-13.358-14.736h-22.124v29.937z"
              opacity="1"
              data-original="#ffca28"
            ></path>
            <path
              fill="#e14844"
              d="M416.101 311.46c50.655 0 91.719 41.064 91.719 91.719H324.383c0-50.655 41.063-91.719 91.718-91.719z"
              opacity="1"
              data-original="#e14844"
            ></path>
            <path
              fill="#cb413d"
              d="M119.33 311.46c50.655 0 91.719 41.064 91.719 91.719h-40.282c-1.285-42.372-29.534-77.959-68.169-90.191a92.147 92.147 0 0 1 16.732-1.528zM416.101 311.46c50.655 0 91.719 41.064 91.719 91.719h-40.282c-1.285-42.372-29.534-77.959-68.17-90.191a92.166 92.166 0 0 1 16.733-1.528z"
              opacity="1"
              data-original="#cb413d"
            ></path>
            <path
              fill="#404049"
              d="M389.952 205.493c8.775 0 15.889 7.114 15.889 15.889s-7.114 15.889-15.889 15.889a15.91 15.91 0 0 1-3.161-.315c7.261-1.465 12.729-7.882 12.729-15.574 0-7.693-5.468-14.109-12.729-15.575a15.977 15.977 0 0 1 3.161-.314zM203.069 205.624l71.558 32.188c9.558 4.299 15.525 13.3 15.273 23.779l-2.421 100.514h8.609l2.914-106.077c.235-9.66-4.82-18.064-13.099-22.687h-.001c-.14-.078-.281-.155-.423-.232h-.001a28.97 28.97 0 0 0-.864-.443c-.146-.071-.292-.142-.44-.212-.148-.069-.296-.138-.445-.205l-130.273-58.6-3.591 7.982z"
              opacity="1"
              data-original="#404049"
            ></path>
            <path
              fill="#ffca28"
              d="M199.608 118.888c15.909-6.606 35.595-10.789 59.993-11.706 3.85 13.549 14.617 27.245 26.275 35.045 2.381 9.42 2.158 17.471 2.158 17.471l21.501 27.687c22.203 8.821 44.354 17.722 66.901 25.639a15.956 15.956 0 0 1 7.249-6.248c-21.388-7.606-42.439-16.069-63.531-24.448l-21.501-27.687s.214-7.705-2.007-16.861c-1.819-7.5-5.271-15.972-11.811-21.979-14.525-13.341-14.615-13.676-14.615-13.676-.782.03-1.56.062-2.333.098-28.996 1.355-51.212 7.4-68.279 16.665z"
              opacity="1"
              data-original="#ffca28"
            ></path>
            <path
              fill="#f6dccd"
              d="M326.214 44.019c24.24 2.357 41.98 23.919 39.622 48.159-2.357 24.24-23.919 41.98-48.158 39.623-24.24-2.357-41.98-23.919-39.623-48.159l43.891 4.268z"
              opacity="1"
              data-original="#f6dccd"
            ></path>
            <path
              fill="#e14844"
              d="M327.356 32.266c25.646 2.494 45.551 21.944 49.701 46.172.635 3.71-.398 7.172-2.96 9.928-2.563 2.756-5.942 4.037-9.688 3.673l-30.835-2.999c-6.405-.623-12.137 4.093-12.76 10.498l-2.997 30.829c-.365 3.748-2.274 6.818-5.474 8.803-3.2 1.984-6.799 2.33-10.318.991-22.97-8.743-38.216-32.021-35.723-57.663 2.988-30.729 30.324-53.22 61.054-50.232z"
              opacity="1"
              data-original="#e14844"
            ></path>
            <path
              fill="#cb413d"
              d="M327.356 32.266c25.646 2.494 45.551 21.944 49.701 46.172.635 3.71-.398 7.172-2.96 9.928-2.232 2.401-5.084 3.682-8.258 3.732.004-.258.01-.515.01-.774 0-30.161-24.45-54.612-54.612-54.612-6.03 0-11.831.98-17.255 2.784a55.658 55.658 0 0 1 33.374-7.23z"
              opacity="1"
              data-original="#cb413d"
            ></path>
          </g>
          <path
            d="m439.704 307.193-11.268-52.095c8.092 1.033 16.248-1.59 23.039-7.428 9.852-8.469 15.971-22.761 15.971-37.298 0-14.293-6.32-28.961-16.1-37.37-7.011-6.028-15.155-8.542-23.549-7.267l-55.337 8.4c-8.436 1.279-14.724 7.958-15.641 16.249-9.236-3.572-18.59-7.292-28.63-11.285l-4.395-1.748-18.647-24.011a77.58 77.58 0 0 0-.251-4.124c.266.012.533.037.799.037 3.364 0 6.678-.95 9.706-2.828 2.544-1.578 4.588-3.628 6.064-6.029 11.626-.038 22.794-4.042 31.892-11.528s15.178-17.67 17.456-29.07c2.642-.985 5.048-2.596 7.087-4.789 4.03-4.334 5.699-9.934 4.7-15.765-4.722-27.577-27.49-48.729-55.366-51.44-34.182-3.322-64.691 21.779-68.016 55.959a61.952 61.952 0 0 0 .199 13.713c-58.341 4.629-94.947 29.345-111.739 75.425l-5.846 12.996v-75.974c0-10.425-8.482-18.907-18.907-18.907H18.907C8.482 91.016 0 99.498 0 109.923v104.019c0 10.425 8.482 18.907 18.907 18.907h53.196a26.897 26.897 0 0 0-3.583 13.435v12.161c-26.769 12.597-45.351 39.819-45.351 71.311v71.775a7 7 0 0 0 7 7h8.048c3.569 42.479 39.259 75.961 82.644 75.961s79.075-33.483 82.644-75.961h128.159c3.569 42.479 39.259 75.961 82.645 75.961 43.385 0 79.075-33.483 82.644-75.961H505a7 7 0 0 0 7-7c0-45.087-30.703-83.13-72.296-94.338zm-3.121-126.946c1.929.691 3.813 1.804 5.636 3.372 6.715 5.773 11.227 16.524 11.227 26.753 0 10.413-4.356 20.886-11.098 26.682-1.468 1.262-3.425 2.601-5.765 3.436zm-65.893 12.231c0-2.305 1.591-4.156 3.87-4.501l48.023-7.29v59.369l-17.655-2.68c3.86-4.073 6.235-9.566 6.235-15.607 0-12.523-10.188-22.711-22.711-22.711-2.13 0-4.19.301-6.146.852a972.016 972.016 0 0 1-11.615-4.25v-3.182zm26.473 29.291c0 4.804-3.908 8.711-8.711 8.711s-8.711-3.908-8.711-8.711 3.908-8.711 8.711-8.711 8.711 3.908 8.711 8.711zM370.69 246.34l42.937 6.517 11.148 51.543a98.357 98.357 0 0 0-10.467-.562c-15.667 0-30.481 3.713-43.618 10.296zm-26.227-128.282c-5.715 4.702-12.559 7.505-19.767 8.179l2.36-24.269a4.558 4.558 0 0 1 4.973-4.091l24.267 2.36c-2.052 6.944-6.118 13.119-11.833 17.821zm-71.309-32.939c2.423-24.917 23.48-43.609 48.017-43.609 1.556 0 3.129.075 4.709.229 21.611 2.102 39.262 18.496 42.922 39.87.259 1.514-.107 2.743-1.154 3.869-1.045 1.125-2.245 1.583-3.774 1.431l-30.49-2.965c-10.179-.991-19.271 6.489-20.262 16.67l-2.964 30.484c-.149 1.531-.827 2.622-2.134 3.432-1.308.811-2.586.934-4.024.388-20.264-7.714-32.948-28.192-30.846-49.799zm-10.391 26.129c4.974 13.505 14.544 25.102 27.263 32.465 1.257 6.612 1.153 11.822 1.152 11.869a7.006 7.006 0 0 0 1.469 4.487l21.26 27.376a7.01 7.01 0 0 0 2.944 2.212l6.165 2.451c16.319 6.49 30.837 12.264 46.03 17.874a22.564 22.564 0 0 0-3.259 10.411l-63.075-18.558-36.81-29.341a6.998 6.998 0 0 0-7.431-.818l-44.741 21.815-50.179-22.571c16.126-37.049 47.919-56.153 99.212-59.672zm23.527 114.883-55.946-25.166 30.288-14.768 34.425 27.439a7.019 7.019 0 0 0 2.387 1.242l59.247 17.432v90.38a98.548 98.548 0 0 0-19.532 18.98H303.17l2.348-85.452c.358-13.061-7.009-24.591-19.228-30.087zm-145.136 7.079c3.578 4.482 8.257 7.836 13.693 9.713l23.332 8.057h-76.234c-6.702 0-13.208.847-19.424 2.429v-7.126c0-7.208 5.865-13.073 13.074-13.073zm-82.23-128.194h23.987v40.723H58.924zM18.907 218.849A4.912 4.912 0 0 1 14 213.942V109.923a4.912 4.912 0 0 1 4.907-4.907h26.017v40.878c0 7.634 5.731 13.845 12.776 13.845h26.434c7.045 0 12.776-6.211 12.776-13.845v-40.878h26.016a4.912 4.912 0 0 1 4.907 4.907v104.019a4.912 4.912 0 0 1-4.907 4.907zm101.954 251.642c-35.663 0-65.088-27.211-68.607-61.961h24.321c3.371 21.41 21.945 37.837 44.287 37.837s40.916-16.427 44.287-37.837h24.321c-3.521 34.75-32.947 61.961-68.609 61.961zM90.835 408.53h60.052c-3.18 13.641-15.431 23.837-30.026 23.837s-26.846-10.196-30.026-23.837zm-53.351-14c3.571-42.881 39.588-76.691 83.377-76.691s79.806 33.81 83.377 76.691zm180.815 0c-3.601-50.612-45.925-90.691-97.439-90.691-35.465 0-66.574 18.998-83.692 47.349v-21.432c0-35.717 29.058-64.774 64.775-64.774h116.775l18.182 6.279v77.412a7 7 0 0 0 7 7h10.584l-.041 3.867c-.084.419-.13.852-.135 1.294l-.14 11.841c-.077 6.604 2.503 12.853 7.267 17.594a25.287 25.287 0 0 0 5.718 4.261zm32.602-52.859v-65.578l4.401 1.52-.671 64.058zm13.739-75.644L159.417 229.69c-4.381-1.512-7.895-4.894-9.895-9.522-2.378-5.505-2.33-12.057.13-17.525l8.464-18.816 52.86 23.777 69.57 31.294c7.077 3.184 11.18 9.515 10.976 16.937l-2.694 98.081h-20.324l.85-81.199a6.998 6.998 0 0 0-4.714-6.69zm49.391 115.5a5.956 5.956 0 0 1-4.226 1.792l-16.716.108-13.653.224c-3.024.049-5.966-1.156-8.123-3.304-2.061-2.051-3.178-4.718-3.145-7.507l.058-4.923H294.5v-.102a6.97 6.97 0 0 0 1.139.102h13.484c3.721.546 6.611 3.833 6.635 7.616l.011 1.746a5.96 5.96 0 0 1-1.738 4.248zm10.949-19.526a21.717 21.717 0 0 0-8.257-6.33h11.348a97.682 97.682 0 0 0-3.091 6.33zm89.329 108.49c-35.663 0-65.089-27.211-68.608-61.961h24.321c3.371 21.41 21.945 37.837 44.287 37.837s40.916-16.427 44.287-37.837h24.321c-3.52 34.75-32.946 61.961-68.608 61.961zm-30.026-61.961h60.052c-3.18 13.641-15.431 23.837-30.026 23.837s-26.846-10.196-30.026-23.837zm-53.376-14c3.568-42.884 39.611-76.691 83.402-76.691 43.79 0 79.833 33.807 83.401 76.691z"
            fill="#000000"
            opacity="1"
            data-original="#000000"
          ></path>
        </g>
      </svg>
    </div>
  );
}
